import { IADocsSourceName } from '../Helpers/AppHelper';
import { ICoveoSiteConfig, SiteNames } from '../Models/CoveoModels';

export const CoveoSiteConfig: Array<ICoveoSiteConfig> = [
  {
    siteName: SiteNames.plsite,
    search: {
      additionalSites: [SiteNames.news],
      additionalSources: [IADocsSourceName],
    },
  },
  {
    siteName: SiteNames.pldemosite,
    search: {
      additionalSites: [SiteNames.newsdemo],
      additionalSources: [IADocsSourceName],
    },
  },
  {
    siteName: SiteNames.blsite,
    search: {
      additionalSites: [],
      additionalSources: [IADocsSourceName],
    },
  },
  {
    siteName: SiteNames.bldemosite,
    search: {
      additionalSites: [],
      additionalSources: [IADocsSourceName],
    },
  },
  {
    siteName: SiteNames.obplsite,
    search: {
      additionalSites: [SiteNames.news],
      additionalSources: [IADocsSourceName],
    },
  },  
  {
    siteName: SiteNames.obpldemosite,
    search: {
      additionalSites: [SiteNames.newsdemo],
      additionalSources: [IADocsSourceName],
    },
  },
  {
    siteName: SiteNames.obblsite,
    search: {
      additionalSites: [],
      additionalSources: [IADocsSourceName],
    },
  },  
  {
    siteName: SiteNames.obbldemosite,
    search: {
      additionalSites: [],
      additionalSources: [IADocsSourceName],
    },
  },
];

export function getCoveoSiteConfigByName(pSiteName: string): ICoveoSiteConfig | undefined {
  return CoveoSiteConfig.find(
    (pSiteConfig: ICoveoSiteConfig) => pSiteConfig.siteName.toLowerCase() === pSiteName.toLowerCase(),
  );
}
